export const styledReportStatsGiveaway = () => /* css */`

@page {
    margin: 0mm;
}

/* Elementos que não serão mostrados na página */
.header-report,
.footer-report,
.line-divider{
    display: flex !important;
}

.header-report {
    align-items: center;
    justify-content: space-between;
    height: 120px;
    margin-left: 15mm;
    margin-right: 15mm;
    border-radius: 8px 0 0 8px;
}

.footer-report {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 0;
}

.footer-report,
.footer-report-img {
    z-index: -1;
    height: 250px;
    margin-bottom: -1px;
}

.footer-report-logo-img {
    position: absolute;
    z-index: 1000;
    bottom: 0;
    margin-bottom: 50px;
    padding: 15px;
    margin-left: 15mm;
}


.footer-report-date-generated {
    padding: 5px 0;
    text-align: center;
    width: 100%;
    font-size: 12px;
    z-index: 1000;
    bottom: 0;
    position: absolute;
}

.footer-report-date-generated>p {
    color: #fff;
    margin-bottom: 22px;
    font-size: 14px;
}

.page {
    page-break-after: always;
}

.header-info h1 {
    font-size: 1.5rem;
    /* equivalente a text-2xl */
    font-weight: bold;
    color: #1e293b;
    margin-bottom: 4px;
}

.header-info p {
    font-size: 1.125rem;
    /* equivalente a text-lg */
    color: #6b7280;
}

.header-logo img {
    max-width: 200px;
    max-height: 80px;
    /* w-24 */
    object-fit: contain;
}

@media print {
    .header-info h1 {
        margin-top: 30px;
        max-width: 100%;
    }

    .header-info p {
        font-size: 1rem;
    }

    .header-logo img {
        margin-right: 30mm;
    }

    body {
        -webkit-print-color-adjust: exact;
        margin: 0mm;
    }

    .footer-report {
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
    }

    .header-report {
        display: flex;
        position: fixed;
        width: 100%;
        top: 0;
    }

    .line-divider {
        margin-top: 110px;
        margin-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
    }

    .line-divider {
        display: block;
    }

    .section-report {
        margin-left: 15mm !important;
        margin-right: 15mm !important;
    }

    .section-title {
        font-size: 16px !important;
        margin-bottom: 16px !important;
        color: #2c3e50 !important;
    }

    .section-text {
        color: #251E1E !important;
    }

    .section-label {
        color: #6c757d !important;
    }


    .report-card,
    .info-item,
    .card-distribution,
    .ant-card,
    .winners-card-item {
        background: #ffffff !important;
        border: 1px solid #e2e8f0 !important;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
    }

    .report-table {
        background-color: #fff;
    }

    .winners-card-item { 
        page-break-inside: avoid; 
        page-break-after: auto;
    }


}

.report-card {
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
    font-family: Arial, sans-serif;
}


.section-label {
    font-size: 12px;
    color: #6c757d;
    letter-spacing: 0.05em;
    margin-bottom: 10px;
    font-weight: 500;
}

.color-green {
    color: #15803d !important;
}

.logo-img {
    max-height: 150px;
    max-width: 250px;
    object-fit: contain;
}

`
